import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = {
  class: "col",
  style: {"height":"200px","overflow-y":"auto"}
}
const _hoisted_9 = { class: "input-group input-group-sm mb-1" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "input-group-append" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "input-group input-group-sm mb-1" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "input-group-append" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row mb-4" }
const _hoisted_19 = {
  class: "col",
  style: {"height":"200px","overflow-y":"auto"}
}
const _hoisted_20 = { class: "input-group input-group-sm mb-1" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "input-group-append" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "input-group input-group-sm mb-1" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "input-group-append" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "row mb-4" }
const _hoisted_30 = {
  class: "col",
  style: {"height":"200px","overflow-y":"auto"}
}
const _hoisted_31 = { class: "input-group input-group-sm mb-1" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = { class: "input-group-append" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "input-group input-group-sm mb-1" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "input-group-append" }
const _hoisted_39 = ["onClick"]

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelinePropertiesPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelinePropertiesPage',
  setup(__props) {

    document.title = "Configure properties"

    const tid = useOrganizationUnitId()
    const id = useId()

    const datasetId = ref()
    const connectorId = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useDatasetPropertyNamesQuery,
        useConnectorPropertyNamesQuery,
        usePipelinePropertyNamesQuery,
        useExcludePipelineDatasetPropertyCommand,
        useIncludePipelineDatasetPropertyCommand,
        useExcludePipelineConnectorPropertyCommand,
        useIncludePipelineConnectorPropertyCommand,
        useExcludePipelinePropertyCommand,
        useIncludePipelinePropertyCommand
    } = useAdminConfigurePipelinePropertiesPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const datasetProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.DatasetProperties)
    const connectorProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.ConnectorProperties)
    const pipelineProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.PipelineProperties)

    const { runDatasetPropertyNamesQueryV1, modelDatasetPropertyNamesQueryV1 } = useDatasetPropertyNamesQuery(datasetId)
    const datasetPropertyNames = computed<string>(() => modelDatasetPropertyNamesQueryV1.value?.PropertyNames || [])

    const { dataStream, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1 } = useConnectorPropertyNamesQuery(connectorId)
    const connectorPropertyNames = computed<string>(() => modelConnectorPropertyNamesQueryV1.value?.PropertyNames || [])

    const { runPipelinePropertyNamesQueryV1, modelPipelinePropertyNamesQueryV1 } = usePipelinePropertyNamesQuery(id)
    const pipelinePropertyNames = computed<string>(() => modelPipelinePropertyNamesQueryV1.value?.PropertyNames || [])

    const { invokeIncludePipelineDatasetPropertyCommandV1, succeedIncludePipelineDatasetPropertyCommandV1 } = useIncludePipelineDatasetPropertyCommand(id, tid, userId)
    const { invokeExcludePipelineDatasetPropertyCommandV1, succeedExcludePipelineDatasetPropertyCommandV1 } = useExcludePipelineDatasetPropertyCommand(id, tid, userId)

    const { invokeIncludePipelineConnectorPropertyCommandV1, succeedIncludePipelineConnectorPropertyCommandV1 } = useIncludePipelineConnectorPropertyCommand(id, tid, userId)
    const { invokeExcludePipelineConnectorPropertyCommandV1, succeedExcludePipelineConnectorPropertyCommandV1 } = useExcludePipelineConnectorPropertyCommand(id, tid, userId)

    const { invokeIncludePipelinePropertyCommandV1, succeedIncludePipelinePropertyCommandV1 } = useIncludePipelinePropertyCommand(id, tid, userId)
    const { invokeExcludePipelinePropertyCommandV1, succeedExcludePipelinePropertyCommandV1 } = useExcludePipelinePropertyCommand(id, tid, userId)

    const availableDatasetPropertyNames = computed(() => datasetPropertyNames.value.filter(p => !datasetProperties.value.includes(p)))
    const availableConnectorPropertyNames = computed(() => connectorPropertyNames.value.filter(p => !connectorProperties.value.includes(p)))
    const availablePipelinePropertyNames = computed(() => pipelinePropertyNames.value.filter(p => !pipelineProperties.value.includes(p)))

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
        runPipelinePropertyNamesQueryV1()
    })

    watch(connectorId, () => {
        runConnectorPropertyNamesQueryV1()
    })

    watch(datasetId, () => {
        runDatasetPropertyNamesQueryV1()
    })

    watch(modelPipelineDetailsQueryV1, () => {
        datasetId.value = modelPipelineDetailsQueryV1.value.DatasetId
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
        dataStream.value = modelPipelineDetailsQueryV1.value.DataStream
    })

    watch([
        succeedIncludePipelineDatasetPropertyCommandV1,
        succeedExcludePipelineDatasetPropertyCommandV1,
        succeedIncludePipelineConnectorPropertyCommandV1,
        succeedExcludePipelineConnectorPropertyCommandV1,
        succeedIncludePipelinePropertyCommandV1,
        succeedExcludePipelinePropertyCommandV1
    ], () => runPipelineDetailsQueryV1())

    function handleIncludePipelineDatasetPropertyCommandV1(propertyName: string) {
        invokeIncludePipelineDatasetPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelineDatasetPropertyCommandV1(propertyName: string) {
        invokeExcludePipelineDatasetPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleIncludePipelineConnectorPropertyCommandV1(propertyName: string) {
        invokeIncludePipelineConnectorPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelineConnectorPropertyCommandV1(propertyName: string) {
        invokeExcludePipelineConnectorPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleIncludePipelinePropertyCommandV1(propertyName: string) {
        invokeIncludePipelinePropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelinePropertyCommandV1(propertyName: string) {
        invokeExcludePipelinePropertyCommandV1({ PropertyName: propertyName })
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure properties", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("h5", null, "Dataset available", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDatasetPropertyNames.value, (p) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: p,
                disabled: ""
              }, null, 8 /* PROPS */, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleIncludePipelineDatasetPropertyCommandV1(p)),
                  class: "btn btn-outline-primary",
                  type: "button"
                }, "Include", 8 /* PROPS */, _hoisted_12)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[4] || (_cache[4] = _createElementVNode("h5", null, "Dataset included", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datasetProperties.value, (p) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: p,
                disabled: ""
              }, null, 8 /* PROPS */, _hoisted_15),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleExcludePipelineDatasetPropertyCommandV1(p)),
                  class: "btn btn-outline-primary",
                  type: "button"
                }, "Exclude", 8 /* PROPS */, _hoisted_17)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Connector available", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableConnectorPropertyNames.value, (p) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: p,
                disabled: ""
              }, null, 8 /* PROPS */, _hoisted_21),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleIncludePipelineConnectorPropertyCommandV1(p)),
                  class: "btn btn-outline-primary",
                  type: "button"
                }, "Include", 8 /* PROPS */, _hoisted_23)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[6] || (_cache[6] = _createElementVNode("h5", null, "Connector included", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectorProperties.value, (p) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: p,
                disabled: ""
              }, null, 8 /* PROPS */, _hoisted_26),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleExcludePipelineConnectorPropertyCommandV1(p)),
                  class: "btn btn-outline-primary",
                  type: "button"
                }, "Exclude", 8 /* PROPS */, _hoisted_28)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Pipeline available", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availablePipelinePropertyNames.value, (p) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: p,
                disabled: ""
              }, null, 8 /* PROPS */, _hoisted_32),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleIncludePipelinePropertyCommandV1(p)),
                  class: "btn btn-outline-primary",
                  type: "button"
                }, "Include", 8 /* PROPS */, _hoisted_34)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_35, [
          _cache[8] || (_cache[8] = _createElementVNode("h5", null, "Pipeline included", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pipelineProperties.value, (p) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: p,
                disabled: ""
              }, null, 8 /* PROPS */, _hoisted_37),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleExcludePipelinePropertyCommandV1(p)),
                  class: "btn btn-outline-primary",
                  type: "button"
                }, "Exclude", 8 /* PROPS */, _hoisted_39)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

})